/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit';
import { getAllAssetLocationUserList } from './assetLocationAction';

const initialState = {
    data: {},
    assetLocationUsers: {}
}
const assetLocationSlice = createSlice({
    name: 'assetLocation',
    initialState,
    extraReducers: {
        [getAllAssetLocationUserList.fulfilled]: (state, { payload }) => {
            state.assetLocationUsers = payload;
        },
    }
});

export default assetLocationSlice.reducer;